import { createFileRoute } from '@tanstack/react-router'

import { RoleGate } from '@/components/guards'
import { PaymentOptionsSettingsPage } from '@/pages/settings/organization/PaymentOptionsSettingsPage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/settings/organization/payment-options/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <RoleGate requires="ADMIN">
      <PaymentOptionsSettingsPage />
    </RoleGate>
  )
}
